import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { SkeletonInlineDirective } from '@shared/directives/skeleton-inline.directive';

import type { PageHeaderVariant } from './page-header.types';

@Component({
  selector: 'app-page-header',
  imports: [NgTemplateOutlet, RouterModule, MatButtonModule, MatIconModule, SkeletonInlineDirective],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  readonly heading = input.required<string>();
  readonly subtitle = input<string>('');
  readonly backLink = input<string | readonly string[] | null>(null);
  readonly backLabel = input<string>('Voltar');
  readonly variant = input<PageHeaderVariant>('default');
  readonly headingLevel = input<1 | 2>(1);
  readonly isFirstLoad = input<boolean>(false);

  protected readonly isCompact = computed(() => this.variant() === 'compact');
}
